<div class="table-wrapper">
	<div class="detail-table-row-wrapper">
		<table
			mat-table
			class="ob-table ob-table-plain desktop-view breakpoint-md"
			[dataSource]="isLoadingPage ? noRows : dataSource"
			multiTemplateDataRows
			aria-label="table"
		>
			<ng-container [matColumnDef]="COLUMN_DATASET">
				<th mat-header-cell *matHeaderCellDef>
					{{ "i18n.enum.catalog_type.dataset" | translate }}
				</th>
				<td mat-cell *matCellDef="let element">
					<a *ngIf="element.datasetUrl" [href]="element.datasetUrl" [icon]="element.datasetUrl | linkicon">{{
						element.datasetName | fallback: currentLanguage
					}}</a>
					<span *ngIf="!element.datasetUrl">{{ element.datasetName | fallback: currentLanguage }}</span>
				</td>
			</ng-container>

			<ng-container [matColumnDef]="COLUMN_ATTRIBUTE">
				<th mat-header-cell *matHeaderCellDef>
					{{ "i18n.title.attributes" | translate }}
				</th>
				<td mat-cell *matCellDef="let element">
					<a [href]="element.attributeUri" [icon]="element.attributeUri | linkicon">{{ element.attributeName }}</a>
				</td>
			</ng-container>

			<ng-container [matColumnDef]="COLUMN_PUBLISHER">
				<th mat-header-cell *matHeaderCellDef>
					{{ "i18n.property.publisher" | translate }}
				</th>
				<td mat-cell *matCellDef="let element">
					{{ element.publisherName | fallback: currentLanguage }}
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let element; columns: displayedColumns"></tr>
		</table>

		<div class="mobile-view breakpoint-md">
			@for (element of (isLoadingPage ? noRows : dataSource.data); track element) {
				<div class="wrapper plain">
					<div class="row">
						<div class="label">{{ "i18n.enum.catalog_type.dataset" | translate }}</div>
						<div class="value">
							<a *ngIf="element.datasetUrl" [href]="element.datasetUrl" [icon]="element.datasetUrl | linkicon">{{
								element.datasetName | fallback: currentLanguage
							}}</a>
							<span *ngIf="!element.datasetUrl">{{ element.datasetName | fallback: currentLanguage }}</span>
						</div>
					</div>
					<div class="row">
						<div class="label">{{ "i18n.title.attributes" | translate }}</div>
						<div class="value">
							<a [href]="element.attributeUri" [icon]="element.attributeUri | linkicon">{{ element.attributeName }}</a>
						</div>
					</div>
					<div class="row">
						<div class="label">{{ "i18n.property.publisher" | translate }}</div>
						<div class="value">{{ element.publisherName | fallback: currentLanguage }}</div>
					</div>
				</div>
			}
		</div>

		@if (isLoadingPage) {
			<div style="display: flex; justify-content: center; padding: 2rem 0">
				<mat-progress-spinner mode="indeterminate" [diameter]="40" aria-label="Loading"></mat-progress-spinner>
			</div>
		}
		<mat-paginator
			[length]="pagingInfo.totalRows"
			[pageSizeOptions]="pagingInfo.pageSizeOptions"
			[pageSize]="pagingInfo.pageSize"
			[pageIndex]="pagingInfo.page - 1"
			(page)="onChangePage($event)"
		></mat-paginator>
	</div>
</div>
